module.exports = __webpack_public_path__ + "img/1F1E9-1F1F4.4b412955.svg";